enum DashboardTypeEnum {
    SUPPLIER = "SUPPLIER",
    CUSTOMER = "CUSTOMER",
    USER = "USER",
}

export default DashboardTypeEnum;
